<template><div></div></template>

<script>
export default {
  name: 'Logout',
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/')
        })
    }
  },
  created () {
    this.logout()
  }
}
</script>
